export const FILTER_VALUES = [
    {
        label: 'Paid',
        key: 'paid'
    },
    {
        label: 'Unpaid',
        key: 'unpaid'
    },
    {
        label: 'Software Fee',
        key: 'SoftwareFee'
    },
    {
        label: 'Royalty Fee',
        key: 'RoyaltyFee'
    }
]

export const FILTER_OP_MAP : Record<string,string> = {
    paid: 'unpaid',
    unpaid: 'paid',
    SoftwareFee: 'RoyaltyFee',
    RoyaltyFee: 'SoftwareFee'
}

export const PAY_TYPE = ['paid', 'unpaid'];
export const INVOICE_TYPE = ['SoftwareFee', 'RoyaltyFee']